// import { useState, useEffect } from "react";
// import { Loader } from "./common-function";
// import { useNavigate } from "react-router-dom";
// import { createTicket, getIssues } from "./config";
// import userStore from "../../zustand/userStore";
// import { getTicketsList } from "./redux/ticketingSlice";
// import { useDispatch } from "react-redux";

// const MAX_FILES = 5;
// const MAX_TOTAL_SIZE = 10 * 1024 * 1024;

// export default function CreateTicket() {
//   const navigate = useNavigate();
//   const userData = userStore((state) => state.user);
//   const [error, setError] = useState("");
//   const [issues, setIssues] = useState([]);
//   const [data, setData] = useState({
//     list: { initial_list: [] },
//     selected_values: {},
//     files: [],
//     issue_description: "",
//     loader: false,
//   });
//   const dispatch = useDispatch();

//   useEffect(() => {
//     const fetchIssues = async () => {
//       try {
//         const res = await fetch(getIssues);
//         const json = await res.json();
//         const formatted = json.map((i) => ({
//           id: i.id,
//           label: i.issue,
//           parent_id: i.parent_issue_id,
//         }));
//         setIssues(formatted);
//       } catch (e) {
//         console.error("Issue fetch failed:", e);
//       }
//     };
//     fetchIssues();
//   }, []);

//   useEffect(() => {
//     if (issues.length) updateList(null, "initial_list");
//   }, [issues]);

//   const updateList = (parentId, key) => {
//     const filtered = issues.filter(
//       (i) =>
//         (parentId == null && i.parent_id == null) || i.parent_id === parentId
//     );
//     setData((p) => ({
//       ...p,
//       list: { ...p.list, [key]: filtered },
//     }));
//   };

//   const handleInputChange = (option, key, listKey) => {
//     setData((prev) => {
//       const selected = { ...prev.selected_values };
//       Object.keys(selected)
//         .filter((k) => k > key)
//         .forEach((k) => delete selected[k]);

//       const newList = Object.fromEntries(
//         Object.entries(prev.list).filter(
//           ([k]) => !Object.keys(selected).includes(k)
//         )
//       );

//       return {
//         ...prev,
//         selected_values: { ...selected, [key]: option },
//         list: newList,
//       };
//     });
//     if (option) updateList(option.id, listKey);
//   };

//   const renderDropdowns = () => {
//     const dropdowns = [];
//     let showNext = true;

//     for (let i = 0; i < 20; i++) {
//       const currentKey = `selectedValue_${i + 1}`;
//       const listKey = i === 0 ? "initial_list" : `list_${i}`;
//       const nextListKey = `list_${i + 1}`;
//       const selectedId = data.selected_values[currentKey]?.id;

//       if (!data.list[listKey] || !showNext) break;

//       dropdowns.push(
//         <div key={i} style={{ marginTop: "2%" }}>
//           <label>
//             {i === 0
//               ? "Issue"
//               : data.selected_values[`selectedValue_${i}`]?.label || ""}
//           </label>
//           <select
//             className="form-control"
//             value={selectedId || ""}
//             onChange={(e) => {
//               const val = data.list[listKey].find(
//                 (o) => o.id === +e.target.value
//               );
//               handleInputChange(val, currentKey, nextListKey);
//             }}
//           >
//             <option value="">Select...</option>
//             {data.list[listKey]?.map((o) => (
//               <option key={o.id} value={o.id}>
//                 {o.label}
//               </option>
//             ))}
//           </select>
//         </div>
//       );

//       showNext = !!(selectedId && data.list[nextListKey]?.length);
//     }

//     return dropdowns;
//   };

//   const handleFileChange = (e) => {
//     const newFiles = Array.from(e.target.files);
//     const total = [...data.files, ...newFiles];
//     const size = total.reduce((sum, f) => sum + f.size, 0);

//     if (total.length > MAX_FILES) return setError("Max 5 files allowed.");
//     if (size > MAX_TOTAL_SIZE) return setError("Total file size exceeds 10MB.");

//     setError("");
//     setData((p) => ({ ...p, files: total }));
//   };

//   const removeFile = (i) => {
//     if (window.confirm("Remove file?")) {
//       setData((p) => {
//         const files = [...p.files];
//         files.splice(i, 1);
//         return { ...p, files };
//       });
//     }
//   };

//   const handleSubmit = async () => {
//     const lastId = Object.values(data.selected_values).slice(-1)[0]?.id;
//     if (!lastId || !data.issue_description)
//       return alert("Fill required fields.");
//     if (!window.confirm("Raise this issue?")) return;
//     setData((p) => ({ ...p, loader: true }));

//     const formData = new FormData();
//     formData.append(
//       "ticketData",
//       JSON.stringify({
//         user_id: userData?.id,
//         issue_id: lastId,
//         description: data.issue_description,
//         email: userData?.email,
//       })
//     );
//     data.files.forEach((f) => formData.append("files", f));

//     try {
//       const res = await fetch(createTicket, { method: "POST", body: formData });
//       const json = await res.json();
//       alert(json.message || "Success");
//       navigate("/raiseYourConcern?1");
//       await dispatch(getTicketsList());
//     } catch (e) {
//       alert("Failed to submit ticket.");
//     } finally {
//       setData((p) => ({ ...p, loader: false }));
//     }
//   };

//   return (
//     <div>
//       {/* <h2 className="mt-2" style={{ fontSize: "16px", color: "black" }}>
//         Create Ticket
//       </h2> */}
//       <div
//         className="p-3 mt-3 rounded-3 shadow-sm"
//         style={{ background: "#f8f9fa", height: "70vh", overflowY: "auto" }}
//       >
//         {renderDropdowns()}
//         <div className="mb-3">
//           <label className="form-label">
//             Description <span className="text-danger">*</span>
//           </label>
//           <textarea
//             className="form-control"
//             rows="4"
//             value={data.issue_description}
//             onChange={(e) =>
//               setData((p) => ({ ...p, issue_description: e.target.value }))
//             }
//           />
//         </div>

//         <div className="mb-3">
//           <label className="form-label">Upload Attachment</label>
//           <input
//             className="form-control"
//             type="file"
//             multiple
//             accept="image/*,video/*"
//             onChange={handleFileChange}
//           />
//         </div>

//         {data.files.length > 0 && (
//           <ul className="list-group">
//             {data.files.map((f, i) => (
//               <li
//                 key={i}
//                 className="list-group-item d-flex justify-content-between"
//               >
//                 {f.name}
//                 <button
//                   className="btn btn-danger btn-sm"
//                   onClick={() => removeFile(i)}
//                 >
//                   Remove
//                 </button>
//               </li>
//             ))}
//           </ul>
//         )}

//         {error && <p className="text-danger">{error}</p>}

//         <div className="text-center mt-4">
//           <button className="btn btn-success" onClick={handleSubmit}>
//             Submit
//           </button>
//         </div>

//         {data.loader && <Loader />}
//       </div>
//     </div>
//   );
// }

import { useEffect, useState } from "react";
import { Loader } from "./common-function";
import { useLocation, useNavigate } from "react-router-dom";
import userStore from "../../zustand/userStore";
import { useDispatch, useSelector } from "react-redux";
import {
  getIssuesList,
  setError,
  handleInputChangeRedux,
  addFiles,
  removeFile,
  createTicketThunk,
  updateData,
  getTicketsList,
  resetData,
} from "./redux/ticketingSlice";
import { setFiles } from "@testing-library/user-event/dist/cjs/utils/index.js";

const MAX_FILES = 5;
const MAX_TOTAL_SIZE = 10 * 1024 * 1024;

export default function CreateTicket() {
  const navigate = useNavigate();
  const userData = userStore((state) => state.user);
  const dispatch = useDispatch();
  const [contact, setContact] = useState("");
  const { data, error } = useSelector((state) => state.tickets);
  const location = useLocation();
  const state = location.state || {};
  useEffect(() => {
    dispatch(getIssuesList());
  }, [dispatch]);

  const { userId, email } = state;
  useEffect(() => {
    if (state?.contactNumber) {
      setContact(state.contactNumber);
    } else if (userData?.contact_number) {
      setContact(userData.contact_number);
    } else {
      setContact("");
    }
  }, [state?.contactNumber, userData?.contact_number]);
  const renderDropdowns = () => {
    const dropdowns = [];
    let showNext = true;

    for (let i = 0; i < 20; i++) {
      const currentKey = `selectedValue_${i + 1}`;
      const listKey = i === 0 ? "initial_list" : `list_${i}`;
      const nextListKey = `list_${i + 1}`;
      const selectedId = data.selected_values[currentKey]?.id;

      if (!data.list[listKey] || !showNext) break;

      dropdowns.push(
        <div key={i} style={{ marginTop: "2%" }}>
          <label>
            {i === 0
              ? "Issue"
              : data.selected_values[`selectedValue_${i}`]?.label || ""}
          </label>
          <select
            className="form-control"
            value={selectedId || ""}
            onChange={(e) => {
              const val = data.list[listKey].find(
                (o) => o.id === +e.target.value,
              );
              dispatch(
                handleInputChangeRedux({
                  option: val,
                  key: currentKey,
                  listKey: nextListKey,
                }),
              );
            }}
          >
            <option value="">Select...</option>
            {data.list[listKey]?.map((o) => (
              <option key={o.id} value={o.id}>
                {o.label}
              </option>
            ))}
          </select>
        </div>,
      );

      showNext = !!(selectedId && data.list[nextListKey]?.length);
    }

    return dropdowns;
  };

  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files);
    const total = [...data.files, ...newFiles];
    const size = total.reduce((sum, f) => sum + f.size, 0);

    if (total.length > MAX_FILES)
      return dispatch(setError("Max 5 files allowed."));
    if (size > MAX_TOTAL_SIZE)
      return dispatch(setError("Total file size exceeds 10MB."));

    dispatch(setError(""));
    dispatch(addFiles(newFiles));
  };

  const handleSubmit = async () => {
    const lastId = Object.values(data.selected_values).slice(-1)[0]?.id;

    if (!lastId || !data.issue_description) {
      alert("Fill required fields.");
      return;
    }

    if (!window.confirm("Raise this issue?")) return;

    try {
      const response = await dispatch(
        createTicketThunk({
          user_id: userId || userData?.admin_id || null,
          email: email || userData?.email || "",
          lastId,
          mobile_number: contact,
          issue_description: data.issue_description,
          files: data.files,
        }),
      );
      dispatch(resetData());
      dispatch(addFiles([]));
      if (response.type === "ticketing/createTicket/fulfilled") {
        alert(response.payload?.message || "Ticket created successfully");

        dispatch(resetData());
        dispatch(addFiles([]));

        if (userData?.admin_id) {
          dispatch(getTicketsList({ user_id: userData.admin_id }));
          navigate("/viewTickets");
        } else {
          navigate("/home");
        }
      } else {
        alert(
          response.payload?.message ||
            response.error?.message ||
            "Failed to create ticket",
        );
      }

      //       if (response) {
      //         alert(response?.message || "ticket created successfully");
      //       }
      //       // navigate("/view-tickets");
      //       if (userData?.admin_id) {
      //         navigate("/viewTickets");
      //         // await dispatch(getTicketsList());
      //         dispatch(getTicketsList({ user_id: userData?.admin_id }));
      //       }
    } catch (error) {
      console.error("Error creating ticket:", error);
    }
  };

  return (
    <div
      // className="p-3 mt-3 rounded-3 shadow-sm"
      style={
        {
          // // width: "50%",
          // marginTop: "2%",
          // marginLeft: "30%",
          // height: "90vh",
          // marginTop: "0px",
          // backgroundColor: "rgba(169, 137, 243, 0.5)", // 50% opacity
          // borderRadius: "10px",
        }
      }
    >
      {/* <h2 style={{ fontSize: "20px", textAlign: "center", marginTop: "0%" }}>
        Create ticket
      </h2>{" "} */}
      <div
        className="p-3 mt-3 rounded-3 shadow-sm"
        style={{
          // backgroundColor: "rgba(169,137,243,255)",
          //
          border: "1px solid black",
          marginTop: "5%",
          marginLeft: "25%",
          width: "50%",
          backgroundColor: "white",
          height: "80vh",
          overflowY: "auto",
        }}
      >
        <h2 style={{ fontSize: "20px", textAlign: "center", marginTop: "0%" }}>
          Create ticket
        </h2>
        <div className="mb-3">
          <label className="form-label">
            User Contact Number <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            rows="4"
            placeholder={
              !userData?.contact_number && "Enter your mobile number"
            }
            disabled={userData?.contact_number || state?.contactNumber}
            value={contact}
            onChange={(e) => setContact(e.target.value)}
          />
        </div>
        {renderDropdowns()}

        <div className="mb-3" style={{ marginTop: "2%" }}>
          <label className="form-label">
            Description <span className="text-danger">*</span>
          </label>
          <textarea
            className="form-control"
            placeholder="Enter the issue description"
            rows="4"
            value={data.issue_description}
            onChange={(e) =>
              dispatch(updateData({ issue_description: e.target.value }))
            }
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Upload Attachment</label>
          <input
            className="form-control"
            type="file"
            multiple
            accept="image/*,video/*"
            onChange={handleFileChange}
          />
        </div>

        {data.files.length > 0 && (
          <ul className="list-group">
            {data.files.map((f, i) => (
              <li
                key={i}
                className="list-group-item d-flex justify-content-between"
              >
                {f.name}
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => dispatch(removeFile(i))}
                >
                  Remove
                </button>
              </li>
            ))}
          </ul>
        )}

        {error && <p className="text-danger">{error}</p>}

        <div className="text-center mt-4">
          <button className="btn btn-success" onClick={handleSubmit}>
            Submit
          </button>
        </div>

        {data.loader && <Loader />}
      </div>
    </div>
  );
}
